var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWheel28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8477_251855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2547 2.31825C10.717 2.4446 10.4301 3.01313 10.6008 3.53838L11.6515 6.77197C11.8221 7.29722 12.3863 7.57652 12.9313 7.48709C13.639 7.37097 14.361 7.37097 15.0687 7.48709C15.6137 7.57652 16.1779 7.29722 16.3485 6.77197L17.3992 3.53838C17.5699 3.01312 17.283 2.4446 16.7453 2.31825C14.9399 1.89392 13.0602 1.89392 11.2547 2.31825Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91034 7.50393C3.61137 7.96829 3.79994 8.57653 4.28758 8.83581L7.2896 10.432C7.77724 10.6913 8.37708 10.5003 8.707 10.0574C9.1354 9.48225 9.65478 8.98069 10.2445 8.57262C10.6987 8.25836 10.9105 7.66555 10.6684 7.16916L9.17793 4.11326C8.93582 3.61687 8.33453 3.40719 7.86002 3.68977C6.26649 4.63873 4.91434 5.94448 3.91034 7.50393Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42612 17.032C2.89523 17.1842 2.33707 16.8777 2.22955 16.336C1.86849 14.5168 1.93409 12.6382 2.42118 10.8486C2.56622 10.3157 3.14441 10.0489 3.66339 10.2378L6.85834 11.4006C7.37732 11.5895 7.63675 12.1631 7.52836 12.7046C7.38761 13.4079 7.36241 14.1294 7.45376 14.8407C7.52411 15.3885 7.2253 15.9426 6.69441 16.0948L3.42612 17.032Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15576 23.8568C7.60941 24.1718 8.22386 24.0046 8.5 23.5263L10.2 20.5818C10.4761 20.1035 10.3062 19.4974 9.87507 19.1522C9.31523 18.704 8.83211 18.1674 8.44486 17.5638C8.14665 17.0989 7.56159 16.8666 7.05705 17.0912L3.951 18.4741C3.44646 18.6987 3.21592 19.2923 3.48177 19.7764C4.37454 21.4021 5.63231 22.799 7.15576 23.8568Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8221 4.11327C19.0642 3.61688 19.6655 3.4072 20.14 3.68978C21.7335 4.63874 23.0857 5.94449 24.0897 7.50393C24.3886 7.9683 24.2001 8.57654 23.7124 8.83582L20.7104 10.432C20.2228 10.6913 19.6229 10.5003 19.293 10.0574C18.8646 9.48225 18.3452 8.9807 17.7555 8.57263C17.3013 8.25837 17.0895 7.66556 17.3316 7.16917L18.8221 4.11327Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5788 10.8486C25.4338 10.3157 24.8556 10.0489 24.3366 10.2378L21.1417 11.4006C20.6227 11.5895 20.3633 12.1631 20.4716 12.7047C20.6124 13.4079 20.6376 14.1294 20.5462 14.8408C20.4759 15.3885 20.7747 15.9426 21.3056 16.0948L24.5739 17.032C25.1048 17.1842 25.6629 16.8777 25.7704 16.336C26.1315 14.5168 26.0659 12.6382 25.5788 10.8486Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.049 18.4741C24.5535 18.6987 24.7841 19.2923 24.5182 19.7764C23.6255 21.4021 22.3677 22.799 20.8442 23.8568C20.3906 24.1718 19.7761 24.0046 19.5 23.5263L17.8 20.5818C17.5239 20.1035 17.6938 19.4974 18.1249 19.1522C18.6848 18.704 19.1679 18.1674 19.5551 17.5638C19.8534 17.0989 20.4384 16.8666 20.9429 17.0912L24.049 18.4741Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1651 20.75C15.2029 19.0834 12.7973 19.0834 11.835 20.75L9.66997 24.5C9.28508 25.1667 9.7662 26 10.536 26H17.4642C18.234 26 18.7151 25.1667 18.3302 24.5L16.1651 20.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8477_251855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel28);
export default __webpack_public_path__ + "static/media/wheel_28.ce92b50c.svg";
export { ForwardRef as ReactComponent };